import { html, render } from "lit-html";
import { translate } from "@escapio/shared/l10n/translate";
import { getFormatter } from "@escapio/shared/l10n/currency";
import { travelData } from "@escapio/portal/state/travelData";
import { hasEscapioRate } from "@escapio/portal/state/escapio-deals-helpers";
import { linkTargetForProfile } from "../../hotel-list/get-offer-url";
import { addEventTrackerData } from "@escapio/portal/tracker/EventQueue";
import "@escapio/shared/components/Picture";
import "@escapio/portal/components/hotel-list/hotel-element/MobileStage";
import "@escapio/portal/components/hotel-list/hotel-element/MobileDescription";
import { hasDirectLink } from "@escapio/portal/state/DirectLink";

class PopupContent extends HTMLElement {
	constructor() {
		super();
		this.hotel = null;
		this.prices = null;
	}

	async connectedCallback() {
		this.render();
	}

	render() {
		render(this.template, this, { host: this });
	}

	get template() {
		return html`<esc-hotel-list-hotel-stage-mobile
				.hotel="${this.hotel}"
				track-category="Karte"
				picture-gallery-track-action-suffix=" (${this.trackName})"
				favorites-track-action-suffix=" (${this.trackName})"
				.profileLinkHandler="${this.trackProfileLinkClickV1("Bild")}"
			></esc-hotel-list-hotel-stage-mobile>
			<a href=${this.hotel.path} target=${linkTargetForProfile}
				><esc-hotel-list-hotel-description-mobile
					.hotel=${this.hotel}
					@click="${this.trackProfileLinkClickV1("Hotelname")}"
				></esc-hotel-list-hotel-description-mobile>
			</a>
			<div class="map-hotel-popup__cta-container">${this.ctaTemplate}</div>`;
	}

	get ctaTemplate() {
		const format = getFormatter(travelData.currency);

		const goToProfileTemplate = html`<a
			href="${this.hotel.path}"
			@click=${this.onProfileLinkOnCTAClick}
			target=${linkTargetForProfile}
		>
			<span class="map-hotel-popup__cta--edl"
				>${translate("hotel_go_to_profile")}</span
			>
		</a>`;

		if (!travelData.hasDates) {
			return goToProfileTemplate;
		}

		if (this.prices.isLoading) {
			return html`<div
				class="map-hotel-popup__cta-placeholder content-placeholder"
			></div>`;
		}

		if (this.prices.hasOffers) {
			return html`<a
				href="${this.hotel.path}"
				@click=${this.trackProfileLinkClickV1("Preis")}
				target=${linkTargetForProfile}
			>
				<small class="map-hotel-popup__before-price">
					${translate("basic_from")}
				</small>
				<span class="map-hotel-popup__cta">
					${format(this.prices.bestPrice)}
				</span>
			</a>`;
		}

		if (hasEscapioRate(this.hotel) || hasDirectLink(this.hotel)) {
			return goToProfileTemplate;
		}

		return html`<div class="map-hotel-popup__cta--price-error">
			${translate("hotel_list_offers_error_loading_price")}
		</div>`;
	}

	onProfileLinkOnCTAClick() {
		this.dispatchEvent(
			new CustomEvent("PopupProfileLink", {
				detail: { element: "Alle Details" },
			}),
		);
	}

	trackProfileLinkClickV1(origin) {
		return () =>
			addEventTrackerData(
				"Karte",
				`Klick Profil (${this.trackName})`,
				`${origin} - ${this.hotel.id} | ${this.hotel.name}`,
			);
	}
}

customElements.define("esc-maplibre-popup", PopupContent);
